import {
  RESTAURANT_LOCATION_SEARCH_REQUEST,
  RESTAURANT_LOCATION_SEARCH_SUCCESS,
  RESTAURANT_LOCATION_SEARCH_FAILURE,
  CLEAR_LOCATION_QUERY,
  CHANGE_HIGHLIGHTED_SUGGESTION,
  GOOGLE_MAPS_GEOLOCATION_REQUEST,
  GOOGLE_MAPS_GEOLOCATION_SUCCESS,
  GOOGLE_MAPS_GEOLOCATION_FAILURE,
  GOOGLE_MAPS_SUGGESTIONS_REQUEST,
  GOOGLE_MAPS_SUGGESTIONS_SUCCESS,
  GOOGLE_MAPS_SUGGESTIONS_FAILURE,
  GOOGLE_MAPS_PLACES_REQUEST,
  GOOGLE_MAPS_PLACES_SUCCESS,
  GOOGLE_MAPS_PLACES_FAILURE,
  GOOGLE_MAPS_CLEAR_SUGGESTIONS,
  GOOGLE_MAPS_SELECT_SUGGESTION_SUCCESS,
  GOOGLE_MAPS_SELECT_SUGGESTION_FAILURE,
  GOOGLE_MAPS_GEOCODE_REQUEST,
  GOOGLE_MAPS_GEOCODE_SUCCESS,
  GOOGLE_MAPS_GEOCODE_FAILURE,
} from '../../actions/types';

export const initialState = {
  loading: false,
  isLocating: false,
  formattedAddress: undefined,
  placeId: undefined,
  coords: undefined,
  isLocationAccurate: undefined,
  suggestions: [],
  highlightedSuggestion: undefined,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESTAURANT_LOCATION_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RESTAURANT_LOCATION_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case RESTAURANT_LOCATION_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case CLEAR_LOCATION_QUERY:
      return initialState;
    case CHANGE_HIGHLIGHTED_SUGGESTION: {
      const { highlightedSuggestion } = action.payload;
      return {
        ...state,
        highlightedSuggestion,
      };
    }
    case GOOGLE_MAPS_GEOLOCATION_REQUEST:
      return {
        ...state,
        isLocating: true,
      };
    case GOOGLE_MAPS_GEOLOCATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLocating: false,
        error: undefined,
      };
    case GOOGLE_MAPS_GEOLOCATION_FAILURE:
      return {
        ...state,
        isLocating: false,
        error: {
          status: action.status,
        },
      };
    case GOOGLE_MAPS_SUGGESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GOOGLE_MAPS_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        suggestions: action.payload.suggestions,
      };
    case GOOGLE_MAPS_SUGGESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: { status: action.status },
      };
    case GOOGLE_MAPS_CLEAR_SUGGESTIONS:
      return {
        ...state,
        suggestions: [],
      };
    case GOOGLE_MAPS_SELECT_SUGGESTION_SUCCESS: {
      const {
        formattedAddress,
        placeId,
        coords,
        postalCode,
        isLocationAccurate,
      } = action.payload.selectedSuggestion;
      return {
        ...state,
        suggestions: [],
        formattedAddress,
        placeId,
        coords,
        postalCode,
        isLocationAccurate,
      };
    }
    case GOOGLE_MAPS_SELECT_SUGGESTION_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    case GOOGLE_MAPS_GEOCODE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GOOGLE_MAPS_GEOCODE_SUCCESS: {
      const {
        formattedAddress,
        placeId,
        coords,
        postalCode,
        isLocationAccurate,
      } = action.payload.addressFields;

      return {
        ...state,
        loading: false,
        formattedAddress,
        placeId,
        coords,
        postalCode,
        isLocationAccurate,
      };
    }
    case GOOGLE_MAPS_GEOCODE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case GOOGLE_MAPS_PLACES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GOOGLE_MAPS_PLACES_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case GOOGLE_MAPS_PLACES_FAILURE:
      return {
        loading: false,
        error: {
          status: action.status,
        },
      };
    default:
      return state;
  }
}
